export type BreadCrumb = {
  i18n: string[];
  route: string;
  private: boolean;
};

const IngresseBreadCrumb: BreadCrumb[] = [
  {
    i18n : ['BREAD_CRUMB', 'TXT_1'],
    route : 'tickets',
    private : false,
  },
  {
    i18n : ['BREAD_CRUMB', 'TXT_3'],
    route : 'naming',
    private : true,
  },
  {
    i18n : ['BREAD_CRUMB', 'TXT_4'],
    route : 'payment',
    private : true,
  },
];

export default IngresseBreadCrumb;
